import { Link } from "react-router-dom";

/**
 * Migas de pan para rutas de nivel ≥2.
 *
 * No está en SYSTEM_DESIGN.md; sale del mockup. El BO tiene rutas profundas
 * (/soporte/articulos/:id, /events/cancellations) y hoy no hay forma de saber
 * dónde estás parado ni de subir un nivel sin usar el menú.
 */
export interface Crumb {
  label: string;
  to?: string;
}

export const Breadcrumb = ({ items }: { items: Crumb[] }) => {
  if (items.length === 0) return null;

  return (
    <nav aria-label="Ruta de navegación" className="flex align-items-center gap-2 text-sm mb-3">
      {items.map((c, i) => {
        const last = i === items.length - 1;
        return (
          <span key={`${c.label}-${i}`} className="flex align-items-center gap-2">
            {c.to && !last ? (
              <Link to={c.to} className="text-600 no-underline hover:underline">
                {c.label}
              </Link>
            ) : (
              <span className={last ? "font-semibold" : "text-600"} aria-current={last ? "page" : undefined}>
                {c.label}
              </span>
            )}
            {!last && <span className="text-400">›</span>}
          </span>
        );
      })}
    </nav>
  );
};
